/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminProductConsistencyDescriptionsResp
 */
export interface AdminProductConsistencyDescriptionsResp {
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminProductConsistencyDescriptionsResp
     */
    items?: Array<string>;
}

export function AdminProductConsistencyDescriptionsRespFromJSON(json: any): AdminProductConsistencyDescriptionsResp {
    return AdminProductConsistencyDescriptionsRespFromJSONTyped(json, false);
}

export function AdminProductConsistencyDescriptionsRespFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminProductConsistencyDescriptionsResp {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': !exists(json, 'items') ? undefined : json['items'],
    };
}

export function AdminProductConsistencyDescriptionsRespToJSON(value?: AdminProductConsistencyDescriptionsResp | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': value.items,
    };
}

